/*
* Wird aufgerufen, um UI seitig einen eingeloggten Nutzer zu erzwingen, wenn eine Aktion ausgeführt werden soll. Muss trotzdem Backend seitig geprüft werden.
* */
import {showToast} from "../ui";
import {t} from "../../i18n";

export function forceUserLogin(callback, errorCallback = null) {
    $.ajax({
        url: '/isAuth',
        async: true,
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        success: function (data) {
            if (!data.isAuth) {
                getLoginDialog(callback, errorCallback);
            } else {
                callback();
            }
        },
        error: function (e) {
            if (errorCallback !== null) {
                errorCallback();
            }
        }
    });
}

function getLoginDialog(callback, errorCallback = null) {
    $.ajax({
        url: 'getDialog/login-dialog',
        async: true,
        success: function (data) {
            $('body').append(data);
            $('#submit-login').on('click', function (e) {
                e.preventDefault();
                login(callback, errorCallback);
            });
            $('#register-now').on('click', () => {
                getRegisterDialog(callback, errorCallback);
            });
        },
        error: () => {
            if (errorCallback !== null) {
                errorCallback();
            }
        }
    });
}

function getRegisterDialog(callback, errorCallback = null) {
    $.ajax({
        url: 'getRegisterDialog',
        async: true,
        success: function (data) {
            $('body').append(data);
            $('#login-dialog').remove();
            $('#register-submit').on('click', function (e) {
                e.preventDefault();
                register(callback, errorCallback);
            });
        },
        error: () => {
            if (errorCallback !== null) {
                errorCallback();
            }
        }
    });
}

function login(callback, errorCallback = null) {
    let email = $('input[id="email"]');
    let pw = $('input[id="password"]');

    $.ajax({
        url: '/login',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            '_method': 'POST'
        },
        data: {
            email: email.val(), password: pw.val()
        },
        method: "POST",
        async: true,
        success: function (data) {
            $('#login-dialog').remove();
            callback();

        }, error: function (e) {
            let errors = e.responseJSON.errors;
            if (errors.email) {
                errors.email.forEach((value) => {
                    showToast(value, "Fehler");
                });
            }
            if (errors.password) {
                errors.password.forEach((value) => {
                    showToast(value, "Fehler");
                });
            }

            if (errorCallback !== null) {
                errorCallback();
            }
        }
    });
}

function register(callback, errorCallback = null) {
    let email = $('input[id="email"]');
    let name = $('input[id="name"]');
    let country = $('select[id="country"]');
    let pw = $('input[id="password"]');
    let pwConf = $('input[id="password_confirmation"]');

    if (!$('#privacy_policy_accepted').is(':checked')) {
        showToast(t("privacy_required"), "Fehler");
        return;
    }

    let data = {
        email: email.val(),
        name: name.val(),
        country: country.val(),
        password: pw.val(),
        password_confirmation: pwConf.val()
    };

    if ($('#newsletter').is(':checked')) {
        data.newsletter = "on";
    }
    if ($('#privacy_policy_accepted').is(':checked')) {
        data.privacy_policy_accepted = "on";
    }

    $.ajax({
        url: '/register',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            '_method': 'POST'
        },
        data: data,
        method: "POST",
        async: true,
        success: function (data) {
            $('#register-dialog').remove();
            callback();
        }, error: function (e) {
            let errors = e.responseJSON.errors;
            if (errors.email) {
                errors.email.forEach((value) => {
                    showToast(value, "Fehler");
                });
            }
            if (errors.password) {
                errors.password.forEach((value) => {
                    showToast(value, "Fehler");
                });
            }

            if (errorCallback !== null) {
                errorCallback();
            }
        }
    });
}
